import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsProfileForm } from './components/form/profileForm';
import { SettingsProfileFormOld } from './components/form/profileFormOld';

export const SettingsProfileView = (): JSX.Element => {
  const { personalSettingsRevamp } = useFeatureFlag([
    'personal-settings-revamp',
  ]);

  return personalSettingsRevamp ? (
    <SettingsProfileForm />
  ) : (
    <SettingsProfileFormOld />
  );
};
